import React from 'react';
import { motion } from 'framer-motion';
import { CTAButton, CHECKOUT_URL } from './CTAButton';
import { TodayOfferCard } from './TodayOfferCard';
const rows = [{
  label: 'Workbook 1 — The Matter & Change Workbook',
  price: '$47 USD'
}, {
  label: 'Workbook 2 — Atomic Structure & Trends Tracker',
  price: '$47 USD'
}, {
  label: 'Workbook 3 — The Bonding & Lewis Script',
  price: '$47 USD'
}, {
  label: 'Workbook 4 — Reaction & Stoichiometry Lab-on-Paper',
  price: '$47 USD'
}, {
  label: 'Workbook 5 — Organic Chemistry & Bio-Systems',
  price: '$47 USD'
}, {
  label: 'Bonus 1 — Dual-Version Assessment Vault',
  price: '$47 USD'
}, {
  label: 'Bonus 2 — Science Comics Engagement Pack',
  price: '$47 USD'
}, {
  label: 'Bonus 3 — Visual Lab Station Playbook',
  price: '$47 USD'
}, {
  label: 'Bonus 4 — Visual Chemistry Cheat-Sheet Library',
  price: '$47 USD'
}];
export function ValueStack() {
  return <section id="get-access" className="w-full scroll-mt-20 bg-white px-5 py-12 sm:py-20" data-id="element-234" data-mp="35pd4rm7gorhs">
      <motion.div initial={{
      opacity: 0,
      y: 20
    }} whileInView={{
      opacity: 1,
      y: 0
    }} viewport={{
      once: true,
      amount: 0.2
    }} transition={{
      duration: 0.5
    }} className="mx-auto max-w-[600px]" data-id="element-235" data-mp="1tetma2kudrs6">
        <h2 className="text-center font-serif-display text-2xl font-bold text-ink sm:text-4xl" data-id="element-236" data-mp="236r5nwm07q1z">
          Everything you get today
        </h2>

        <div className="mt-6 rounded-2xl border border-cobalt/25 p-4 sm:mt-8 sm:p-6" data-id="element-237" data-mp="2c5kwf6cnlm7m">
          <ul data-id="element-238" data-mp="2849ezo3xo7ai">
            {rows.map(row => <li key={row.label} className="flex items-center justify-between gap-3 border-b border-dashed border-cobalt/20 py-2 last:border-b-0 sm:py-2.5" data-id="element-239" data-mp="283hj0c6fc7jp">
                <span className="text-[13px] text-ink/80 sm:text-sm" data-id="element-240" data-mp="2h5h014hfvbmn">{row.label}</span>
                <span className="shrink-0 text-[13px] font-medium text-ink/60 sm:text-sm" data-id="element-241" data-mp="rr2hx30xen04">
                  {row.price}
                </span>
              </li>)}
          </ul>

          <div className="my-4 h-px w-full bg-cobalt/30" data-id="element-242" data-mp="2mu7ibyx0yps7" />

          <div className="flex items-center justify-between" data-id="element-243" data-mp="2rs910iqjgn35">
            <span className="text-[13px] text-ink/60 sm:text-sm" data-id="element-244" data-mp="2rssgztwmp1ej">Total value</span>
            <span className="text-lg font-medium text-ink/50 line-through sm:text-xl" data-id="element-245" data-mp="2vt2o59w5pxuz">
              $423 USD
            </span>
          </div>

          <div className="mt-4 flex flex-col items-center rounded-xl bg-cobalt/10 py-5 text-center sm:py-6" data-id="element-246" data-mp="30qkpof7uhasy">
            <span className="text-sm font-medium text-cobalt-deep" data-id="element-247" data-mp="3ar4shmb0inda">Your price today</span>
            <span className="font-serif-display text-5xl font-bold text-cobalt sm:text-6xl" data-id="element-248" data-mp="3aos52tmhjksu">
              $27 USD
            </span>
            <p className="mt-2 px-4 text-xs text-ink/60 sm:text-sm" data-id="element-249" data-mp="3jjojq1oz5po3">
              One-time payment · No subscription · Lifetime access · Printable PDF
            </p>
          </div>
        </div>

        <div className="mt-6 sm:mt-8" data-id="element-250" data-mp="3tgt9ebi1439n">
          <div className="mb-8 flex flex-col items-center text-center" data-id="element-251" data-mp="3thvzih7j21oi">
            <span className="text-xs font-bold uppercase tracking-widest text-cobalt-deep" data-id="element-252" data-mp="7h6npqbsfp6b">
              Order today and receive this free
            </span>
            <h3 className="mt-2 font-serif-display text-2xl font-bold leading-tight text-ink sm:text-3xl" data-id="element-253" data-mp="3tndguktyh3j1">
              The Visual Chemistry <span className="text-cobalt" data-id="element-254" data-mp="3pmjsxrgijoq5">Quick-Start Guide™</span>
            </h3>
            <p className="mt-2 text-base font-medium text-ink/70 sm:text-lg" data-id="element-255" data-mp="q76bm9vw6y85">
              Your first full week of lessons — already planned, already structured, already ready
              to print.
            </p>

            <div className="mt-6 w-full overflow-hidden rounded-xl border border-cobalt/20 bg-paper shadow-sm" data-id="element-256" data-mp="gfs4bfxp8u4g">
              <img src="https://cdn.magicpatterns.com/patterns/generated-images/7377189f-af18-4473-8f9d-539caebae2b4.jpg" alt="The Visual Chemistry Quick-Start Guide booklet with a printed one-week lesson planner" loading="lazy" className="aspect-video w-full object-cover" data-id="element-257" data-mp="cegp84cgbrai" />
            </div>
          </div>

          <CTAButton label="GET INSTANT ACCESS — ONLY $27" href={CHECKOUT_URL} external data-id="element-258" data-mp="toiw5137gj4c" />
          <TodayOfferCard data-id="element-259" data-mp="fohydui8lrt3" />
          <div className="mt-4 rounded-xl border border-cobalt/20 bg-cobalt/5 px-4 py-3 text-center" data-id="element-260" data-mp="fpaum1jkkywz">
            <p className="text-sm font-bold text-cobalt-deep" data-id="element-261" data-mp="jptn7xtae908">🔒 Secure checkout</p>
            <p className="mt-1 text-xs leading-relaxed text-ink/70 sm:text-sm" data-id="element-262" data-mp="17g7916la3bmd">
              All major credit and debit cards accepted. Your $27 payment is processed securely.
            </p>
            <p className="mt-2 text-xs leading-relaxed text-ink/60" data-id="element-263" data-mp="ylj63n36e60q">
              Instant download delivered to your inbox immediately.
            </p>
          </div>
        </div>
      </motion.div>
    </section>;
}